
















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TextInput, Uploader, PickerInput } from '@/components';
import { Button, Dialog, Toast, Popup } from 'vant';
import { FileType } from '@/common/ts/enum';
import { save } from './api';
import * as config from './config';
import { ZxEditor } from 'zx-editor';
Vue.use(Toast)
  .use(Popup)
  .use(Dialog)
  .use(Button);
@Component({
  components: {
    TextInput,
    Uploader,
    PickerInput,
  },
})
export default class Register extends Vue {
  options = config.OPTHINES;
  pointOut = false;
  noButton = true;
  goldShow = true;
  showIndex: number = 0;

  logoText = 'Logo*';
  contentText = '品牌描述*';
  FileType = FileType;
  healthPickerData: any[] = [];
  // 需要传的参数
  ztype: any; // 参评奖项

  title: string = ''; // 企业名称
  subtitle: string = ''; // 申报人姓名
  tailTitle: string = ''; // 申报联络人姓名
  phone: string = ''; // 申报人联系电话
  corporation: string = ''; // 法人姓名
  onephone: string = ''; // 申报人电话
  threephone: string = ''; // 法人电话
  cover: any[] = []; // 照片
  content: string = ''; // 简介
  zxEditor: any = null;

  testData = [
    [
      {
        title: '企业名称',
        placeholder: '企业名称',
        type: 'input',
        filed: '',
        name: 'title',
      },
      {
        title: '申报联络人姓名',
        placeholder: '申报联络人姓名',
        type: 'input',
        filed: '',
        name: 'tailTitle',
      },
      {
        title: '联系电话*',
        type: 'input',
        placeholder: '联系电话',
        form: 'phone',
        filed: '',
        name: 'towphone',
      },
      {
        title: '药房所属企业法人姓名',
        type: 'input',
        placeholder: '药房所属企业法人姓名',
        filed: '',
        name: 'corporation',
      },
      {
        title: '法人手机',
        type: 'input',
        placeholder: '法人手机',
        form: 'phone',
        filed: '',
        name: 'threephone',
      },
      {
        title: '企业LOGO*',
        type: 'file',
        placeholder: '企业LOGO',
        filed: 'cover',
      },
      {
        title: '企业简介:（300字左右）',
        type: 'text',
        placeholder: '企业简介:（300字左右）',
        arr: [
          '企业简介:（300字左右）',
          '申报人主要事迹（300字左右）',
          '店铺简介*:（300字左右））',
          '申报人主要事迹（300字左右）',
        ],
      },
    ],

    [
      {
        title: '申报人姓名',
        placeholder: '申报人姓名',
        type: 'input',
        filed: '',
        name: 'subtitle',
      },
      {
        title: '申报人联系电话',
        placeholder: '申报人联系电话',
        type: 'input',
        filed: '',
        name: 'onephone',
      },
      {
        title: '所属单位名称',
        type: 'input',
        placeholder: '所属单位名称',
        filed: '',
        name: 'title',
      },

      {
        title: '企业法人姓名',
        type: 'input',
        placeholder: '企业法人姓名',
        filed: '',
        name: 'corporation',
      },
      {
        title: '法人电话',
        type: 'input',
        placeholder: '法人电话',
        filed: '',
        name: 'threephone',
      },
      {
        title: '申报联络人姓名',
        type: 'input',
        placeholder: '申报联络人姓名',
        filed: '',
        name: 'tailTitle',
      },
      {
        title: '联系手机',
        type: 'input',
        placeholder: '联系手机',
        filed: '',
        name: 'towphone',
      },
      {
        title: '申报人寸照',
        type: 'file',
        placeholder: '申报人寸照',
        filed: '',
      },
      {
        title: '申报人主要事迹（300字左右）',
        type: 'text',
        placeholder: '申报人主要事迹（300字左右）',
        filed: '',
      },
    ],

    [
      {
        title: '药店名称',
        placeholder: '药店名称',
        type: 'input',
        filed: '',
        name: 'title',
      },
      {
        title: '药店所属企业法人姓名',
        placeholder: '药店所属企业法人姓名',
        type: 'input',
        filed: '',
        name: 'corporation',
      },
      {
        title: '法人手机',
        type: 'input',
        placeholder: '法人手机',
        filed: '',
        name: 'threephone',
      },
      {
        title: '申报联络人姓名',
        type: 'input',
        placeholder: '申报联络人姓名',
        filed: '',
        name: 'tailTitle',
      },
      {
        title: '联系电话*',
        type: 'input',
        placeholder: '联系电话',
        filed: '',
        name: 'towphone',
      },

      {
        title: '店铺门头外观照片',
        type: 'file',
        placeholder: '店铺门头外观照片',
        filed: '',
      },
      {
        title: '店铺简介:（300字左右）',
        type: 'text',
        placeholder: '店铺简介:（300字左右）',
        filed: '',
      },
    ],

    [
      {
        title: '申报人姓名',
        placeholder: '申报人姓名',
        type: 'input',
        filed: '',
        name: 'subtitle',
      },
      {
        title: '申报人联系电话',
        placeholder: '申报人联系电话',
        type: 'input',
        filed: '',
        name: 'onephone',
      },
      {
        title: '所属单位名称',
        type: 'input',
        placeholder: '所属单位名称',
        filed: '',
        name: 'title',
      },
      {
        title: '企业法人姓名',
        type: 'input',
        placeholder: '企业法人姓名',
        filed: '',
        name: 'corporation',
      },
      {
        title: '法人电话',
        type: 'input',
        placeholder: '法人电话',
        filed: '',
        name: 'threephone',
      },
      {
        title: '申报联络人姓名',
        type: 'input',
        placeholder: '申报联络人姓名',
        filed: '',
        name: 'tailTitle',
      },
      {
        title: '联系手机*',
        type: 'input',
        placeholder: '联系手机',
        filed: '',
        name: 'towphone',
      },
      {
        title: '申报人寸照',
        type: 'file',
        placeholder: '申报人寸照',
        filed: '',
      },
    ],
  ];

  created() {
    const a = / */;
    for (const item of this.options.healthType) {
      this.healthPickerData.push(item.shortName);
    }
    // 初始化富文本编辑器
  }
  mounted() {
    this.zxEditor = new ZxEditor('#editorContainer', {
      showToolbar: false,
      autoSave: 0,
    });
    setTimeout(() => {
      const editorContainerIntro = document.querySelector(
        '#editorContainer .zxeditor-content-wrapper',
      ) as HTMLElement;
      editorContainerIntro.style.cssText = `
      padding: 0 0.6rem; height: 6rem; border: 1px dashed #eee`;
    }, 20);
  }
  fetchHealthData(e: string, index: number) {
    this.ztype = index + 1;
    this.showIndex = index;
  }
  getOssImagesUrls(result: any) {
    this.cover = result;
  }
  verifyData(data: any) {
    const mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(199[0-9]{8})$/;
    const tell = /^0\d{2,3}-?\d{7,8}$/;
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const ele = data[`${key}`];

        if (key.search('phone') !== -1) {
          if (!mobile.test(data[key]) && !tell.test(data[key])) {
            Toast.fail('请输入正确联系方式');
            return false;
          }
        }
      }
    }
  }
  async enterSave() {
    const data: any = {};
    data.ztype = this.ztype;
    for (const item of this.testData[this.showIndex]) {
      if ((item.title as string).indexOf('*') !== -1) {
        if (item.filed === '') {
          console.log(item.name);
          Toast.fail('带*号为必填项');
          return false;
        }
      }
      if (item.filed !== '') {
        data[`${item.name}`] = item.filed;
      }
    }
    console.log('a');
    data.cover = this.cover;
    data.content = this.zxEditor.getContent();
    if (this.cover && this.cover.length <= 0) {
      Toast.fail('请上传照片');
      return false;
    }
    if (!this.zxEditor.getContent(true)) {
      Toast.fail('请填写简介');
      return false;
    }
    const is = this.verifyData(data);
    if (is === false) {
      return;
    }
    const res = await save(data);
    this.successSave(res);
    return;

    // if (!this.ztype) {
    //   Toast.fail('请选择参评奖项');
    //   return false;
    // }
    // if (!this.title) {
    //   Toast.fail('请输入单位名称');
    //   return false;
    // }
    // if (!this.lpphone) {
    //   Toast.fail('请填写法人代表联系电话');
    //   return false;
    // } else {
    //   const mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(199[0-9]{8})$/;
    //   const tell = /^0\d{2,3}-?\d{7,8}$/;
    //   if (!mobile.test(this.lpphone) && !tell.test(this.lpphone)) {
    //     Toast.fail('请输入正确法人代表联系方式');
    //     return false;
    //   }
    // }
    // if (!this.phone) {
    //   Toast.fail('请填写申报人联系电话');
    //   return false;
    // } else {
    //   const mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(199[0-9]{8})$/;
    //   const tell = /^0\d{2,3}-?\d{7,8}$/;
    //   if (!mobile.test(this.phone) && !tell.test(this.phone)) {
    //     Toast.fail('请输入正确申报人联系方式');
    //     return false;
    //   }
    // }
    // if (this.cover && this.cover.length <= 0) {
    //   Toast.fail('请上传单位照片');
    //   return false;
    // }
    // if (!this.content) {
    //   Toast.fail('请填写单位简介');
    //   return false;
    // }
  }
  successSave(res: any) {
    if (res.code === 500) {
      Toast.fail(res.msg);
    } else if (res.code === 200) {
      Toast.success('提交成功，请等待审核！');
      setTimeout(() => {
        this.$router.go(0);
      }, 500);
    } else {
      Toast('未知错误请联系后台');
    }
  }
}
